module.exports = __webpack_public_path__ + "img/red_light.62d0e267.png";